import "./Team.module.css";
import Header from "@/reusable_sections/Header";
import DeExperts from "./sections/DeExperts";
import WhyAcVanDijk from "./sections/WhyAcVanDijk";
import CareersAtVanDijkPartners from "./sections/CareersAtVanDijkPartners";
import Footer from "@/reusable_sections/Footer";
export default function TeamPage() {
  return <div>
      <Header />
      <DeExperts />
      <WhyAcVanDijk />
      <CareersAtVanDijkPartners />
      <Footer />
    </div>;
}